<template>
  <div>
    <vs-tabs>
      <vs-tab label="Список адресов">
        <vs-row class="mb-10">
          <vs-button
            @click="activeCreatePrompt = true"
            class="rounded-full"
            color="primary"
            icon-pack="feather"
            icon="icon-plus-circle"
            type="filled"
            >Добавить адрес</vs-button
          >
        </vs-row>

        <vx-card
          title="Фильтры"
          class="p-1 mb-3 passes__filter-card"
          style="background: #e3e6fd"
          collapseAction
        >
          <div class="flex flex-wrap items-center justify-between w-full">
            <div
              class="header-filter md:w-1/3 md:px-2 w-full mb-2 cursor-pointer"
            >
              <v-select
                :options="countItemsOmPage"
                :clearable="false"
                v-model="countElements"
                style="background-color: #fff"
                placeholder="Количество адресов"
              >
                <div slot="no-options">Совпадений не найдено</div>
              </v-select>
            </div>

            <div
              class="header-filter md:w-1/3 md:px-2 w-full mb-2 cursor-pointer"
            >
              <vs-input
                class="w-full"
                placeholder="Номер участка"
                v-model="filter.homestead_number"
              />
            </div>

            <div
              class="header-filter md:w-1/3 md:px-2 w-full mb-2 cursor-pointer"
            >
              <v-select
                @input="filterHomes"
                label="name"
                :options="countyType"
                :reduce="(name) => name.id"
                :clearable="true"
                v-model="filter.county_type"
                placeholder="Выбор поселения"
                style="background-color: #fff"
              >
                <div slot="no-options">Совпадений не найдено</div>
              </v-select>
            </div>
          </div>
        </vx-card>

        <vx-card title="Список домов" class="p-6">
          <vs-table
            :data="homes"
            :stripe="true"
            :search="false"
            :pagination="false"
            :maxItems="200"
            noDataText="Элементов не найдено"
            id="div-with-loading"
          >
            <template slot="thead">
              <vs-th> # </vs-th>
              <vs-th sort-key="address"> Адрес </vs-th>
              <vs-th> Номер участка </vs-th>
              <vs-th> Счетчики </vs-th>
              <vs-th> Действия </vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].id">
                  {{ data[indextr].id }}
                </vs-td>

                <vs-td :data="data[indextr].address">
                  <p class="mb-3">
                    <vs-icon
                      class="mr-2"
                      icon-pack="feather"
                      icon="icon-home"
                      color="primary"
                    ></vs-icon>
                    Поселок {{ data[indextr].county_type.name }}
                  </p>
                  <p class="mb-3">
                    <vs-icon
                      class="mr-2"
                      icon-pack="feather"
                      icon="icon-home"
                      color="primary"
                    ></vs-icon>
                    Адрес: {{ data[indextr].address }}
                  </p>
                </vs-td>

                <vs-td>
                  {{ data[indextr].homestead_number }}
                </vs-td>

                <vs-td>
                  <p
                    v-for="(counter, index) in data[indextr].counters"
                    :key="index"
                    class="mb-2"
                  >
                    Тип счетчика: {{ counter.kind.name }} | #{{
                      counter.counter_number
                    }}
                  </p>
                </vs-td>

                <vs-td>
                  <vx-tooltip class="inline-block" text="Добавить счетчик">
                    <vs-button
                      @click="openAddMeter(data[indextr].id)"
                      color="dark"
                      class="text-dark mr-3"
                      icon-pack="feather"
                      icon="icon-plus"
                      size="large"
                      type="flat"
                    ></vs-button>
                  </vx-tooltip>
                  <vx-tooltip class="inline-block" text="Редактировать адрес">
                    <vs-button
                      @click="openModalEditHome(data[indextr].id)"
                      color="dark"
                      class="text-dark mr-3"
                      icon-pack="feather"
                      icon="icon-edit"
                      size="large"
                      type="flat"
                    ></vs-button>
                  </vx-tooltip>
                  <vx-tooltip class="inline-block" text="Удалить адрес">
                    <vs-button
                      @click="openModalDeleteHome(data[indextr].id)"
                      color="dark"
                      class="text-dark"
                      icon-pack="feather"
                      icon="icon-trash"
                      size="large"
                      type="flat"
                    ></vs-button>
                  </vx-tooltip>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <vs-pagination
            class="mt-4"
            :total="totalPagePagination"
            v-model="currentPagingationPage"
          ></vs-pagination>
        </vx-card>
      </vs-tab>
      <vs-tab label="Карта жителей">
        <vx-card title="Карта жителей" class="p-6">
          <yandex-map
            style="height: 650px"
            :coords="[55.47699, 37.153121]"
            :zoom="15"
          >
            <ymap-marker
              v-for="(data, index) in mapData"
              :key="index"
              :marker-id="index"
              :coords="data.position"
              :hint-content="data.infoText"
              :icon="markerIcon"
            />
          </yandex-map>
        </vx-card>
      </vs-tab>
    </vs-tabs>

    <vs-popup title="Добавить адрес" :active.sync="activeCreatePrompt">
      <div class="loading-wrap vs-con-loading__container">
        <label class="vs-input--label">Поселок</label>
        <v-select
          label="name"
          :options="countyType"
          :reduce="(name) => name.id"
          :clearable="false"
          v-model="newHome.county_type"
        >
          <div slot="no-options">Совпадений не найдено</div>
        </v-select>

        <vs-input
          class="w-full mb-4"
          v-validate="'required'"
          data-vv-validate-on="blur"
          label="Адрес"
          name="Адрес"
          v-model="newHome.address"
        />
        <span class="text-danger text-sm">{{ errors.first("Адрес") }}</span>

        <vs-input
          class="w-full mb-4"
          v-validate="'required'"
          data-vv-validate-on="blur"
          label="Номер участка"
          name="Номер участка"
          v-model="newHome.homestead_number"
        />
        <span class="text-danger text-sm">{{
          errors.first("Номер участка")
        }}</span>

        <div class="popup-footer mt-4">
          <vs-button
            @click="createHome"
            :disabled="!validateForm"
            class="mr-5 vs-con-loading__container"
            ref="loadableButton"
            type="relief"
            vslor="primary"
            >Создать</vs-button
          >
          <vs-button
            @click="activeCreatePrompt = !activeCreatePrompt"
            color="dark"
            type="border"
            >Отмена</vs-button
          >
        </div>
      </div>
    </vs-popup>

    <vs-popup
      title="Добавить счетчик"
      :active.sync="activeAddMeterPrompt"
      :button-close-hidden="true"
    >
      <div class="loading-wrap vs-con-loading__container">
        <label class="vs-input--label">Тип счетчика</label>
        <v-select
          label="name"
          :options="meterType"
          :reduce="(name) => name.id"
          :clearable="false"
          v-model="newMeter.kind"
        >
          <div slot="no-options">Совпадений не найдено</div>
        </v-select>

        <vs-input
          class="w-full mb-4"
          v-validate="'required'"
          data-vv-validate-on="blur"
          label="Номер счетчика"
          name="Номер счетчика"
          v-model="newMeter.counter_number"
        />
        <span class="text-danger text-sm">{{
          errors.first("Номер счетчика")
        }}</span>

        <div class="popup-footer mt-4">
          <vs-button
            @click="addMeter"
            :disabled="!validateAddMeterForm"
            class="mr-5 vs-con-loading__container"
            ref="loadableButton"
            type="relief"
            vslor="primary"
            >Добавить</vs-button
          >
          <vs-button @click="clearNewMeter" color="dark" type="border"
            >Отмена</vs-button
          >
        </div>
      </div>
    </vs-popup>

    <vs-popup
      v-if="homeDelete !== null"
      title="Вы действительно хотите удалить?"
      :active.sync="activeDeletePrompt"
    >
      <p class="font-semibold mb-5">
        Участок
        <span class="text-danger text-lg"
          >#{{ homeDelete.homestead_number }},
          {{ homeDelete.county_type.name }}</span
        >
        будет удален безвозвратно
      </p>
      <vs-button @click="deleteHome" color="danger" class="mr-5" type="filled"
        >Удалить</vs-button
      >
      <vs-button @click="activeDeletePrompt = false" color="dark" type="border"
        >Отмена</vs-button
      >
    </vs-popup>

    <vs-popup
      v-if="homeEdit"
      title="Редактировать адрес"
      :active.sync="activeEditPrompt"
    >
      <div class="loading-wrap vs-con-loading__container">
        <label class="vs-input--label">Поселок</label>
        <v-select
          label="name"
          :options="countyType"
          :clearable="false"
          v-model="homeEdit.county_type"
        >
          <div slot="no-options">Совпадений не найдено</div>
        </v-select>

        <vs-input
          class="w-full mb-4"
          v-validate="'required'"
          data-vv-validate-on="blur"
          label="Адрес"
          name="Адрес"
          v-model="homeEdit.address"
        />
        <span class="text-danger text-sm">{{ errors.first("Адрес") }}</span>

        <vs-input
          class="w-full mb-4"
          v-validate="'required'"
          data-vv-validate-on="blur"
          label="Номер участка"
          name="Номер участка"
          v-model="homeEdit.homestead_number"
        />
        <span class="text-danger text-sm">{{
          errors.first("Номер участка")
        }}</span>

        <div class="popup-footer mt-4">
          <vs-button
            @click="updateHome"
            class="mr-5 vs-con-loading__container"
            type="relief"
            vslor="primary"
            >Обновить</vs-button
          >
          <vs-button
            @click="activeEditPrompt = !activeEditPrompt"
            color="dark"
            type="border"
            >Отмена</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { API_URL, meterType, countyType, countItemsOmPage } from "@/.env";

import { yandexMap, ymapMarker } from "vue-yandex-maps";

export default {
  data: () => ({
    homes: [],
    newHome: {
      county_type: "",
      address: "",
      homestead_number: "",
    },
    newMeter: {
      id: 0,
      kind: "",
      counter_number: "",
    },
    activeCreatePrompt: false,
    activeAddMeterPrompt: false,

    BASE_URL: API_URL,
    countyType,
    meterType,

    mapData: [],
    markerIcon: {
      layout: "default#imageWithContent",
      imageHref: require("@/assets/images/map/pin.svg"),
      imageSize: [36, 36],
      imageOffset: [-18, -18],
      content: "",
      contentOffset: [0, 15],
      contentLayout: "",
    },

    homeDelete: null,
    activeDeletePrompt: false,

    homeEdit: null,
    activeEditPrompt: false,

    filter: {
      county_type: "",
      homestead_number: "",
    },

    countElements: 20,

    currentPagingationPage: 1,
    totalHomes: 0,
    totalPagePagination: 1,
    countItemsOmPage: countItemsOmPage,
  }),
  components: {
    yandexMap,
    ymapMarker,
  },
  watch: {
    filter: {
      handler(val) {
        this.filterHomes();
      },
      deep: true,
    },
    countElements: function () {
      this.currentPagingationPage = 1;
      this.getAllHomes();
    },
    currentPagingationPage: function () {
      this.getAllHomes();
    },
  },
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.newHome.address !== "" &&
        this.newHome.homestead_number !== "" &&
        this.newHome.county_type !== ""
      );
    },
    validateAddMeterForm() {
      return (
        !this.errors.any() &&
        this.newMeter.kind !== "" &&
        this.newMeter.full_name !== "" &&
        this.newMeter.counter_number !== ""
      );
    },
  },
  methods: {
    filterHomes: _.debounce(function () {
      this.currentPagingationPage = 1;
      this.getAllHomes();
    }, 500),
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    formatDate(date) {
      let now = new Date(date);

      let options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };

      return now.toLocaleString("ru-ru", options);
    },
    createHome() {
      this.$load(async () => {
        let res = await this.$api.homes.createNewHome(this.newHome);

        if (res.status == 200) {
          res.data.county_type = this.countyType.find(
            (x) => x.id == res.data.county_type
          );

          this.homes.splice(0, 0, res.data);
          this.notification("Успешно", "Адрес добавлен", "success");

          this.newHome.address = "";
          this.newHome.homestead_number = "";
          this.activeCreatePrompt = false;
        } else {
          this.notification("Ошибка", "Не удалось создать адрес", "danger");
        }
      });
    },
    openAddMeter(idHome) {
      this.activeAddMeterPrompt = true;
      this.newMeter.id = idHome;
    },
    addMeter() {
      this.$load(async () => {
        let res = await this.$api.homes.addMeter(
          this.newMeter.id,
          this.newMeter
        );

        this.notification("Успешно", "Счетчик добавлен", "success");

        this.clearNewMeter();
      });
    },
    clearNewMeter() {
      this.newMeter = {
        id: 0,
        kind: "",
        counter_number: "",
      };
      this.activeAddMeterPrompt = false;
    },
    getAllHomes() {
      this.$vs.loading();

      this.filter.page =
        this.currentPagingationPage !== 1 ? this.currentPagingationPage : 1;
      this.filter.limit = this.countElements !== 20 ? this.countElements : 20;

      this.$load(async () => {
        let res = (await this.$api.homes.getHomes(this.filter)).data;

        this.totalHomes = res.count;
        this.totalPagePagination = Math.ceil(
          this.totalHomes / this.countElements
        );

        res.results.forEach((home) => {
          if (home.coords) {
            let marker = {
              position: [home.coords.lat, home.coords.lng],
              infoText: `Номер участка: ${home.homestead_number}`,
            };
            this.mapData.push(marker);
          }

          home.county_type = this.countyType.find(
            (x) => x.id == home.county_type
          );

          home.counters.forEach((counter) => {
            counter.kind = this.meterType.find((x) => x.id == counter.kind);
          });
        });

        this.homes = res.results;
        this.$vs.loading.close();
      });
    },
    openModalDeleteHome(idHome) {
      try {
        this.homeDelete = this.homes.find((x) => x.id == idHome);

        this.activeDeletePrompt = true;
      } catch (error) {
        this.notification("Ошибка", "Адрес не найден", "danger");
        this.activeDeletePrompt = false;
      }
    },
    deleteHome() {
      let idHome = this.homeDelete.id;
      if (this.homeDelete !== null) {
        try {
          this.$load(async () => {
            let res = (await this.$api.homes.deleteHome(idHome)).data;

            let index = this.homes.indexOf(this.homeDelete);
            if (index !== -1) {
              this.homes.splice(index, 1);
            }

            this.notification("Успешно", "Адрес удален", "success");
            this.activeDeletePrompt = false;
          });
        } catch (error) {
          this.notification("Ошибка", "Не удалось удалить адрес", "danger");
          this.activeDeletePrompt = false;
        }
      }
    },
    openModalEditHome(idHome) {
      try {
        this.homeEdit = this.homes.find((x) => x.id == idHome);

        this.activeEditPrompt = true;
      } catch (error) {
        this.notification("Ошибка", "Адрес не найден", "danger");
        this.activeEditPrompt = false;
      }
    },
    updateHome() {
      let payload = {
        address: this.homeEdit.address,
        homestead_number: this.homeEdit.homestead_number,
        county_type: this.homeEdit.county_type.id,
      };

      try {
        this.$load(async () => {
          let res = (await this.$api.homes.editHome(this.homeEdit.id, payload))
            .data;

          this.notification("Успешно", "Адрес обновлен", "success");
          this.activeEditPrompt = false;
        });
      } catch (error) {
        this.notification("Ошибка", "Не удалось обновить адрес", "danger");
        this.activeEditPrompt = false;
      }
    },
  },
  created() {},
  mounted() {
    this.getAllHomes();
  },
};
</script>